import { Modal, notification } from "antd";
import { useFormik } from "formik";
import { useEffect, useState } from "react";

import { NuUpload } from "../../../../../../Components/Utils/Input";
import axiosInstance from "../../../../../../Services/axiosCommon";



const ImportManPower = ({ open, onCancel,getData,projectId}) => {
  const [api, contextHolder] = notification.useNotification();
  const [image, setImage] = useState({ preview: "", raw: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [inputKey, setInputKey] = useState(Date.now());

// console.log('====================================');
// console.log(projectId,"dddd");
// console.log('====================================');
useEffect(() => {
  if (open) {
    setImage({ preview: "", raw: "" }); // ✅ Clear file state
    setInputKey(Date.now()); // ✅ Reset file input field
  }
}, [open]);
  const handleChangeImg = (e) => {
    if (e.target.files.length) {
      setImage({
        preview: URL.createObjectURL(e.target.files[0]),
        raw: e.target.files[0],
      });
    }
  };
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: "",
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (value,{resetForm}) => {
      if (!image.raw) {
        api.error({
          message: "Import failed",
          description: "Please upload a file before importing.",
          placement: "bottomRight",
        });
        return;
      }
      setIsLoading(true)
      let formData = new FormData();
      // formik.resetForm({ values: "" });
      formData.append("file", image.raw);
      axiosInstance
        .post(`/man_power_cost/${projectId}/import`,formData)
        .then((res) => {
          console.log(res);
          if (res.status === 201 || res.data.status == true) {
            setIsLoading(false);
            getData();
            resetForm();
            // setImage({ preview: "", raw: "" }); 
            setImage({ preview: "", raw: "" }); // ✅ Clear uploaded file
            setInputKey(Date.now());
            api.success({
              message: `Import successfully`,
              description: res?.data?.msg || "Added in the list",
              placement: "bottomRight",
            });
            onCancel();
          } else {
            setIsLoading(false);
            api.error({
              message: `Import failed`,
              description: res?.data?.msg || "Network error",
              placement: "bottomRight",
            });
          }
        })
        .catch((err) => {
          setIsLoading(false);
          api.error({
            message: `Import failed`,
            description: err?.data?.msg || "Sever error (or) Network error",
            placement: "bottomRight",
          });
        });
    },
  });


  return (
    <>
      {contextHolder}
      <Modal
        open={open}
        title={"Import Manpower"}
        width={"35%"}
        className="my-modal"
        centered
        onCancel={onCancel}
        footer={[]}
      >
        <form onSubmit={formik.handleSubmit}>
          <div className="w-full">
                                 <NuUpload
                                 key={inputKey} 
                                 label="Attachment"
                                 width="w-full "
                                 onChange={handleChangeImg}
                               /> 
                             <div className='flex gap-4 justify-center items-baseline'>
                         <button
                           type="submit"
                           className={ `px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm  rounded-lg mt-4 text-center ${isLoading ? 'bg-red-300 cursor-wait' : 'bg-baseColor-primary'} text-white`}
                           disabled={isLoading}
                         >
                           {isLoading ? 'Importing...' : 'Import'}
                         </button>
                                   <button
                     type="button"
                      onClick={() => {
                  setImage({ preview: "", raw: "" }); // ✅ Clear file state
                  setInputKey(Date.now()); // ✅ Reset file input
                  onCancel();
                }}
                     className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm  text-textColor-main bg-[#E6F2F2] hover:bg-gray-300
                     rounded-md flex items-center`"
                   >
                     Cancel
                   </button> 
                    </div>
                                 </div>
                  
        </form>
      </Modal>
    </>
  );
};

export default ImportManPower;
